// Supported languages for the UNICORP multilingual system.
// English is the default + source of truth and uses unprefixed URLs.
// Architecture is extensible — add a new entry (e.g. zh-Hant) to enable it everywhere.
export const DEFAULT_LANG = "en";

export const LANGUAGES = [
  { code: "en", prefix: "", native: "English", htmlLang: "en", dir: "ltr" },
  { code: "vi", prefix: "vi", native: "Tiếng Việt", htmlLang: "vi", dir: "ltr" },
  { code: "zh-Hans", prefix: "zh-hans", native: "简体中文", htmlLang: "zh-Hans", dir: "ltr" },
  { code: "fr", prefix: "fr", native: "Français", htmlLang: "fr", dir: "ltr" },
  { code: "es", prefix: "es", native: "Español", htmlLang: "es", dir: "ltr" },
];

export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const NON_DEFAULT = LANGUAGES.filter((l) => l.code !== DEFAULT_LANG);

// URL prefix segment (lowercase) -> language code. e.g. "zh-hans" -> "zh-Hans"
export const PREFIX_TO_CODE = LANGUAGES.reduce((m, l) => {
  if (l.prefix) m[l.prefix] = l.code;
  return m;
}, {});

export const byCode = (code) => LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];

// Read the leading language prefix from a pathname. Returns { code, rest }.
export function parsePath(pathname) {
  const seg = pathname.replace(/^\/+/, "").split("/")[0].toLowerCase();
  const code = PREFIX_TO_CODE[seg];
  if (code) {
    const rest = pathname.replace(new RegExp(`^/${seg}`, "i"), "") || "/";
    return { code, rest: rest.startsWith("/") ? rest : "/" + rest };
  }
  return { code: DEFAULT_LANG, rest: pathname || "/" };
}

// Localized path for a given language, preserving the unprefixed English route.
export function localizePath(pathname, code) {
  const { rest } = parsePath(pathname);
  const lang = byCode(code);
  if (!lang.prefix) return rest; // English — unprefixed
  return `/${lang.prefix}${rest === "/" ? "" : rest}`;
}

// Map a (de-prefixed) path to the content namespace it needs fully approved to be
// indexable/hreflang-eligible in a non-English language. Private routes return "private"
// (always noindex). Publishing only shared `global` strings never makes these eligible.
const PRIVATE = ["/admin", "/dashboard", "/login", "/start", "/requests", "/payment", "/u", "/orders", "/profile"];
export function pageNamespace(pathname) {
  const { rest } = parsePath(pathname);
  if (PRIVATE.some((p) => rest === p || rest.startsWith(p + "/"))) return "private";
  if (rest === "/") return "home";
  if (rest === "/company-formation") return "catalog";
  if (rest.startsWith("/company-formation/")) return `country:${rest.split("/")[2] || ""}`;
  if (rest.startsWith("/country/")) return `country:${rest.split("/")[2] || ""}`;
  if (rest === "/banks" || rest === "/bank-compare") return "banks";
  if (rest.startsWith("/bank/")) return `bank:${rest.split("/")[2] || ""}`;
  if (rest.startsWith("/service/")) return `service:${rest.split("/")[2] || ""}`;
  if (rest === "/contact") return "contact";
  if (rest === "/about") return "about";
  if (rest === "/partnership") return "partnership";
  if (rest === "/more-services") return "more";
  if (rest === "/digital-studio") return "digitalStudio";
  if (rest === "/compare") return "compare";
  if (rest === "/payment-gateway") return "paymentGateway";
  if (rest.startsWith("/legal/")) return "legal";
  if (rest === "/advisor") return "advisor";
  return "other";
}
